import * as Scrivito from "scrivito"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"

import { DimConfigurationAdminPageConnector } from "pages/dim-configuration-admin-page/DimConfigurationAdminPageConnector"

import { DimConfigurationAdminPageObjClass } from "./DimConfigurationAdminPageObjClass"

Scrivito.provideComponent(DimConfigurationAdminPageObjClass, () => {
  useScrivitoPage()
  return <DimConfigurationAdminPageConnector />
})
